"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.HistoryPage = exports.HistoryItem = exports.NotificationList = exports.Notification = exports.NotificationDeletePayload = exports.NotificationUpdatePayload = exports.NotificationCreatePayload = exports.ChannelDeletePayload = exports.SmsChannelUpdatePayload = exports.SmsChannelCreatePayload = exports.EmailChannelUpdatePayload = exports.EmailChannelCreatePayload = exports.MobileChannelUpdatePayload = exports.MobileChannelCreatePayload = exports.ChannelList = exports.Channel = exports.ChannelType = exports.TriggerType = exports.TriggerEvent = exports.Scope = exports.ChannelUpsertResult = exports.ChannelCreateResult = exports.NAMESPACE = void 0;
const effect_1 = require("effect");
const Json = __importStar(require("../../../../../json"));
const openapi_1 = require("../../../openapi");
const field_1 = require("../../../openapi/field");
const notification_fields_1 = require("../../shared/notification-fields");
exports.NAMESPACE = 'Culligan.Api.V1.Admin.Notification.Schema';
// Moved to the shared module; re-exported so existing imports keep working.
var notification_1 = require("../../shared/notification");
Object.defineProperty(exports, "ChannelCreateResult", { enumerable: true, get: function () { return notification_1.ChannelCreateResult; } });
Object.defineProperty(exports, "ChannelUpsertResult", { enumerable: true, get: function () { return notification_1.ChannelUpsertResult; } });
Object.defineProperty(exports, "Scope", { enumerable: true, get: function () { return notification_1.Scope; } });
Object.defineProperty(exports, "TriggerEvent", { enumerable: true, get: function () { return notification_1.TriggerEvent; } });
Object.defineProperty(exports, "TriggerType", { enumerable: true, get: function () { return notification_1.TriggerType; } });
const optionalDateTime = (description) => effect_1.Schema.optionalWith((0, field_1.dateTime)(description), { exact: true }).annotations({ description });
exports.ChannelType = effect_1.Schema.Literal('push_mobile', 'email', 'sms', 'webhook', 'webhook_svix').annotations({
    identifier: `${exports.NAMESPACE}.ChannelType`,
});
const channelCommon = {
    ...notification_fields_1.channelKey,
    userId: (0, field_1.nonEmpty)('Owner user id'),
    ...notification_fields_1.channelBase,
};
const MobileChannel = effect_1.Schema.Struct({
    ...channelCommon,
    ...notification_fields_1.mobileChannelBody,
});
const EmailChannel = effect_1.Schema.Struct({
    ...channelCommon,
    ...notification_fields_1.emailChannelBody,
});
const SmsChannel = effect_1.Schema.Struct({
    ...channelCommon,
    ...notification_fields_1.smsChannelBody,
});
/**
 * Admin list strips appId and maps stored id to channelId. Webhook channel
 * variants can also be present even though this router cannot create them.
 */
const OtherChannel = effect_1.Schema.Struct({
    ...channelCommon,
    ...notification_fields_1.webhookChannelBody,
}).pipe(effect_1.Schema.extend(effect_1.Schema.Record({
    key: effect_1.Schema.String,
    value: Json.Value,
})));
exports.Channel = effect_1.Schema.Union(MobileChannel, EmailChannel, SmsChannel, OtherChannel).annotations({
    identifier: `${exports.NAMESPACE}.Channel`,
    description: 'Notification channel returned by the admin channel list',
});
exports.ChannelList = effect_1.Schema.Struct({
    channels: effect_1.Schema.Array(exports.Channel),
}).annotations({
    identifier: `${exports.NAMESPACE}.ChannelList`,
});
const adminChannelOwner = {
    userId: (0, field_1.nonEmpty)('Owner user id'),
    appId: (0, field_1.nonEmpty)('Client application id'),
};
exports.MobileChannelCreatePayload = effect_1.Schema.Struct({
    ...adminChannelOwner,
    ...notification_fields_1.mobileChannelPayloadFields,
}).annotations({
    identifier: `${exports.NAMESPACE}.MobileChannelCreatePayload`,
});
exports.MobileChannelUpdatePayload = effect_1.Schema.Struct({
    channelId: (0, field_1.nonEmpty)('Notification channel id'),
    ...exports.MobileChannelCreatePayload.fields,
}).annotations({
    identifier: `${exports.NAMESPACE}.MobileChannelUpdatePayload`,
    description: 'userId and appId must match the stored channel owner; a mismatch returns 401 (business rule, not a silent overwrite)',
});
exports.EmailChannelCreatePayload = effect_1.Schema.Struct({
    ...adminChannelOwner,
    ...notification_fields_1.emailChannelPayloadFields,
}).annotations({
    identifier: `${exports.NAMESPACE}.EmailChannelCreatePayload`,
});
exports.EmailChannelUpdatePayload = effect_1.Schema.Struct({
    channelId: (0, field_1.nonEmpty)('Notification channel id'),
    ...exports.EmailChannelCreatePayload.fields,
}).annotations({
    identifier: `${exports.NAMESPACE}.EmailChannelUpdatePayload`,
    description: 'userId and appId must match the stored channel owner; a mismatch returns 401 (business rule, not a silent overwrite)',
});
exports.SmsChannelCreatePayload = effect_1.Schema.Struct({
    ...adminChannelOwner,
    ...notification_fields_1.smsChannelPayloadFields,
}).annotations({
    identifier: `${exports.NAMESPACE}.SmsChannelCreatePayload`,
});
exports.SmsChannelUpdatePayload = effect_1.Schema.Struct({
    channelId: (0, field_1.nonEmpty)('Notification channel id'),
    ...exports.SmsChannelCreatePayload.fields,
}).annotations({
    identifier: `${exports.NAMESPACE}.SmsChannelUpdatePayload`,
    description: 'userId and appId must match the stored channel owner; a mismatch returns 401 (business rule, not a silent overwrite)',
});
exports.ChannelDeletePayload = effect_1.Schema.Struct({
    channelId: (0, field_1.nonEmpty)('Notification channel id'),
}).annotations({
    identifier: `${exports.NAMESPACE}.ChannelDeletePayload`,
    description: 'Admin delete only uses channelId; userId and appId are not required at runtime',
});
exports.NotificationCreatePayload = effect_1.Schema.Struct({
    userId: (0, field_1.nonEmpty)('Owner user id'),
    ...notification_fields_1.rulePayloadFields,
}).annotations({
    identifier: `${exports.NAMESPACE}.NotificationCreatePayload`,
});
exports.NotificationUpdatePayload = effect_1.Schema.Struct({
    userId: (0, field_1.nonEmpty)('Owner user id'),
    notificationId: (0, field_1.optionalString)('Notification id'),
    ruleId: (0, field_1.optionalString)('Alias copied to notificationId when notificationId is absent'),
    ...notification_fields_1.rulePayloadFields,
}).annotations({
    identifier: `${exports.NAMESPACE}.NotificationUpdatePayload`,
});
exports.NotificationDeletePayload = effect_1.Schema.Struct({
    userId: (0, field_1.nonEmpty)('Owner user id'),
    notificationId: (0, field_1.optionalString)('Notification id'),
    ruleId: (0, field_1.optionalString)('Alias copied to notificationId when notificationId is absent'),
}).annotations({
    identifier: `${exports.NAMESPACE}.NotificationDeletePayload`,
    description: 'After ruleId→notificationId aliasing, runtime validates only notificationId (not the full create/update rule schema). userId is still required by the admin wrapper.',
});
exports.Notification = effect_1.Schema.Struct({
    ...notification_fields_1.notificationKey,
    userId: (0, field_1.nonEmpty)('Owner user id'),
    ...notification_fields_1.notificationBody,
}).annotations({
    identifier: `${exports.NAMESPACE}.Notification`,
    description: 'Admin notification rule with stored id projected to notificationId and ruleId',
});
exports.NotificationList = effect_1.Schema.Struct({
    notifications: effect_1.Schema.Array(exports.Notification),
}).annotations({
    identifier: `${exports.NAMESPACE}.NotificationList`,
});
exports.HistoryItem = effect_1.Schema.Struct({
    id: (0, field_1.nonEmpty)('History record id'),
    ruleId: effect_1.Schema.String,
    userId: effect_1.Schema.String,
    deviceId: effect_1.Schema.String,
    channelId: effect_1.Schema.String,
    channelType: exports.ChannelType,
    value: effect_1.Schema.NullOr(Json.Value),
    result: effect_1.Schema.NullOr(Json.Value),
    sentAt: (0, field_1.dateTime)('Notification sent time'),
    createdAt: optionalDateTime('ISO-8601 creation time'),
    updatedAt: optionalDateTime('ISO-8601 last update time'),
}).annotations({
    identifier: `${exports.NAMESPACE}.HistoryItem`,
});
exports.HistoryPage = effect_1.Schema.Struct({
    items: effect_1.Schema.Array(exports.HistoryItem),
    page: effect_1.Schema.Int.pipe(effect_1.Schema.positive()),
    itemsCount: effect_1.Schema.Int.pipe(effect_1.Schema.nonNegative()),
    pagesCount: effect_1.Schema.Int.pipe(effect_1.Schema.positive()),
    provider: effect_1.Schema.optionalWith(openapi_1.Response.ProviderMetadata, { exact: true }),
}).annotations({
    identifier: `${exports.NAMESPACE}.HistoryPage`,
});
//# sourceMappingURL=schema.js.map